import styled from "styled-components";

import { LoadingSkeletonSquareContainer } from "shared/components/molecules/LoadingSkeleton/atoms/LoadingSkeletonSquare/styles";

export const PresentationVideoContainer = styled.div`
  transition: all 0.2s ease-in-out;
  position: relative;

  max-width: 44.5rem;

  border-radius: 4px;
  overflow: hidden;

  &,
  ${LoadingSkeletonSquareContainer} {
    aspect-ratio: 390 / 219;
    @media (min-width: 768px) {
      aspect-ratio: 712 / 400;
    }
  }

  img,
  .video-container {
    border: none;
    border-radius: 2px;

    width: 100%;
  }

  img {
    object-fit: cover;
  }
`;
